import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import './shell.css';

interface AppHeaderProps {
  title: ReactNode;
  /** Show a back chevron; string = explicit route, true = history back. */
  back?: string | boolean;
  /** Override the back action (e.g. to guard unsaved changes). Implies a chevron. */
  onBack?: () => void;
  actions?: ReactNode;
  /** Header background; defaults to the brand accent. */
  accent?: string;
}

export function AppHeader({ title, back, onBack, actions, accent }: AppHeaderProps) {
  const navigate = useNavigate();
  const showBack = onBack !== undefined || back !== undefined;

  const handleBack = () => {
    if (onBack) onBack();
    else if (typeof back === 'string') navigate(back);
    else navigate(-1);
  };

  return (
    <header className="app-header" style={accent ? { background: accent } : undefined}>
      <div className="app-header-row">
        {showBack ? (
          <button className="header-icon-btn" aria-label="Back" onClick={handleBack}>
            <ChevronLeft />
          </button>
        ) : (
          <span className="header-icon-btn header-spacer" aria-hidden="true" />
        )}
        <h1 className="app-header-title">{title}</h1>
        <div className="app-header-actions">{actions}</div>
      </div>
    </header>
  );
}

function ChevronLeft() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M15 18l-6-6 6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
